import { createContext, ReactNode, useContext, useEffect, useState } from "react";
import { DEVICE_UUID_STORAGE_KEY, getOrRegisterDevice } from "../api/device";
import { LoadingScreenGlobal } from "../pages/other/LoadingScreen";
import { setBaseAPIDeviceUUID } from "../api/api.base";

type DeviceContextType = {
    deviceUUID: string;
    validatingDevice: boolean;
    setDeviceUUID: (uuid: string) => void;
};

const DeviceContext = createContext<DeviceContextType | undefined>(undefined);

export const useDevice = () => {
    const context = useContext(DeviceContext);
    if (!context) {
        throw new Error("useDevice must be used within DeviceProvider");
    }
    return context;
};

export const DeviceProvider = ({ children }: { children: ReactNode }) => {
    const [deviceUUID, setDeviceUUIDState] = useState<string>("");
    const [validatingDevice, setValidatingDevice] = useState<boolean>(true);

    const setDeviceUUID = (uuid: string) => {
        window.localStorage.setItem(DEVICE_UUID_STORAGE_KEY, uuid);
        setBaseAPIDeviceUUID(uuid);
        setDeviceUUIDState(uuid);
    };

    useEffect(() => {
        const bootstrapDevice = async () => {
            try {
                const uuid = await getOrRegisterDevice();
                setDeviceUUID(uuid);
            } finally {
                setValidatingDevice(false);
            }
        };

        bootstrapDevice();
    }, []);

    if (validatingDevice) {
        console.log("Validating device...");
        return <LoadingScreenGlobal />;
    }
    console.log("Device validated with UUID:", deviceUUID);
    return (
        <DeviceContext.Provider value={{ deviceUUID, validatingDevice, setDeviceUUID }}>
            {children}
        </DeviceContext.Provider>
    );
};
